// extracted by mini-css-extract-plugin
export default {"modal":"codes-module__modal___Hr6aP","loading":"codes-module__loading___yvgl8","not-found":"codes-module__not-found___ISVd7"};